export function getTickerLastUpdatedText(marketTime) {
    let date = new Date(marketTime);
	let day = date.getDate();
	let year = date.getFullYear();
	let month = date.toLocaleString('en-US', { month: "short" });
	let dayName = date.toLocaleString('en-US', { weekday: "long" });
	return `Last updated on ${dayName}, ${month} ${day}, ${year} Price delayed 15 minutes`;
}

export function getChangedStockPriceText(stockSummary) {
    let changePriceNum = (stockSummary.formattedChangePrice.charAt(0) === '-') ? stockSummary.formattedChangePrice.substring(1) : stockSummary.formattedChangePrice;
    let prefixPrice = (stockSummary.formattedChangePrice.charAt(0) === '-') ? '-' : '+';
    let changePrice = `${prefixPrice}$${changePriceNum}`;
    let price = '$'+Number(stockSummary.formattedStockPrice).toFixed(2);
    return `${changePrice} (${stockSummary.formattedChangePercentage})`;
}

export function getIntraDayHigh(stockSummary) {
    return '$' + stockSummary.marketDayHigh;
}

export function getIntraDayLow(stockSummary) {
    return '$' + stockSummary.marketDayLow;
}
